import { Reveal } from "./Reveal";

const studios = ["/studio1.jpg", "/studio2.jpg", "/studio3.jpg"];

export const StudioRefs = () => (
  <section id="referenciak" className="py-24 lg:py-32 bg-[var(--stone-bg)]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="eyebrow text-[var(--terra)] mb-4">Stúdióreferenciák</p>
          <h2 className="font-serif-d font-medium text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Próbálja ki élőben – egy Önhöz közeli stúdióban.
          </h2>
          <p className="mt-6 text-[var(--ink-soft)] leading-relaxed">
            Amennyiben szeretné stúdióreferenciáinkat megtekinteni, megkeressük az
            Önhöz legközelebbit. Gépeink országszerte működnek professzionális
            pilates stúdiókban – vegye fel velünk a kapcsolatot, és egyeztetünk
            egy személyes próbát.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-7 grid grid-cols-3 gap-4">
        {studios.map((src, i) => (
          <Reveal key={src} delay={i * 0.1}>
            <div
              className={`overflow-hidden rounded-2xl ${i === 1 ? "translate-y-8" : ""}`}
              data-testid={`studio-image-${i}`}
            >
              <img src={src} alt={`Referencia stúdió ${i + 1}`} className="w-full h-72 lg:h-96 object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
